// extracted by mini-css-extract-plugin
module.exports = {"container":"_h_Qu3sJ","title":"_1RKstmD","list":"_1jjdOcn","highlight":"_KVUojLb"};